export default "__VITE_PUBLIC_ASSET__38467559__"